var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSort = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 19 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-Product-Setup",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "List-Normal-view",
    transform: "translate(-341.000000, -192.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(341.000000, 194.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(7.000000, 0.000000)",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/desktop/dropdown-Copy",
    transform: "translate(0.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1-Copy",
    points: "6 0 3 3 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon/desktop/dropdown-Copy-2",
    transform: "translate(3.000000, 1.500000) scale(1, -1) translate(-3.000000, -1.500000) "
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1-Copy",
    points: "6 0 3 3 0 0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 6.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 19,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 0,
    y: 4,
    width: 19,
    height: 2
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSort, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sort.d4ac7486.svg";
export { ForwardRef as ReactComponent };